import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export const adminApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

adminApi.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url.startsWith("/auth/")) {
      original._retry = true;
      await adminApi.post("/auth/refresh");
      return adminApi(original);
    }
    return Promise.reject(error);
  }
);

export const accountApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

const NO_RETRY = ["/account/login", "/account/register", "/account/refresh", "/account/logout", "/account/forgot-password", "/account/reset-password", "/account/verify-email"];

accountApi.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !NO_RETRY.includes(original.url)) {
      original._retry = true;
      await accountApi.post("/account/refresh");
      return accountApi(original);
    }
    return Promise.reject(error);
  }
);

export const errorMessage = (err, fallback) => {
  const detail = err?.response?.data?.detail;
  return typeof detail === "string" ? detail : fallback;
};
